import { useEffect, useContext } from 'react';
import { withApollo } from 'react-apollo';
import { StaticContext } from '@sm/webassets';
import { userQuery } from './intercom.graphql';

const loadIntercomSettings = (user, staticContext) => {
  const {
    intercom,
    user: { isAuthenticated, id: userId },
  } = staticContext;
  const settings = {
    app_id: intercom.appId,
  };
  if (isAuthenticated) settings.user_hash = intercom.user_hash;
  if (isAuthenticated && user && userId) {
    settings.user_id = userId;
    settings.name = `${user.firstName} ${user.lastName}`;
    settings.email = user.email;
    settings.created_at = Math.floor(new Date(user.dateJoined).getTime() / 1000);
  }
  window.intercomSettings = settings;
};

const initIntercom = (user, staticContext) => {
  if (!window.intercomSettings) loadIntercomSettings(user, staticContext);
  const { app_id: appId } = window.intercomSettings;
  const scriptSrc = `https://widget.intercom.io/widget/${appId}`;

  const bootIntercom = () => {
    const intercomScript = [...document.getElementsByTagName('script')].filter(s => s.src === scriptSrc);
    if (window.Intercom && window.intercomSettings && intercomScript.length) {
      window.Intercom('boot', window.intercomSettings);
    } else {
      setTimeout(bootIntercom, 150);
    }
  };

  if (typeof window.Intercom === 'function') {
    window.Intercom('reattach_activator');
    window.Intercom('update', window.intercomSettings);
  } else {
    // Intercom provided code
    /* eslint-disable */
    const intercomFunc = function () {
      intercomFunc.c(arguments);
    };
    intercomFunc.q = [];
    intercomFunc.c = function (args) {
      intercomFunc.q.push(args);
    };
    /* eslint-enable */
    window.Intercom = intercomFunc;
    const intercomScript = document.createElement('script');
    intercomScript.type = 'text/javascript';
    intercomScript.async = true;
    intercomScript.src = scriptSrc;
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(intercomScript, firstScript);
    bootIntercom();
  }
};

const Intercom = ({ active, client }) => {
  const staticContext = useContext(StaticContext);
  const {
    intercom: { appId },
  } = staticContext;
  const {
    GDPR: { hasGDPRConsent, isGDPRCountry },
  } = staticContext;
  const loadIntercom = active && (!isGDPRCountry || hasGDPRConsent);
  useEffect(() => {
    if (typeof window !== 'undefined' && window.document && window.document.createElement && active) {
      if (loadIntercom) {
        client
          .query({ query: userQuery })
          .then(({ data }) => {
            if (data) loadIntercomSettings(data.user, staticContext);
            initIntercom(data.user, appId);
          })
          .catch(e => {
            // eslint-disable-next-line no-console
            console.error(e);
            loadIntercomSettings({}, staticContext);
            initIntercom({}, appId);
          });
      }
    }
    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
      if (window.intercomSettings) {
        delete window.intercomSettings;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staticContext.user.id]);

  return null;
};

export default withApollo(Intercom);
